<template>
	<div>
		<header class="lmy-header lmy-header-w">
	        <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
	        确认提现
	    </header>
	    <div class="lmy-withdraw-confirm">
	        <div class="pay-type">
	            <div class="wx-pay">
	                <div class="logo">
	                    <img src="./../../../assets/img/wx.png" alt="">
	                </div>
	                <span class="price">{{Info.CanWithdrawedAmount}}.00</span> 元将提现至您的微信钱包
	            </div>
	        </div>
	        <div class="withdraw-info">
	            <div class="title">请输入真实姓名</div>
	            <div class="withdraw-input">
	                <input type="text" v-model="RealName">
	            </div>
	            <p class="ps">为了您的账户安全，微信将对您进行实名认证</p>
	        </div>
	        <div class="lmy-select-btn" @click="submit()" v-if="!isSubmiting">2小时内到账，确认提现</div>
	        <div class="lmy-select-btn"  v-if="isSubmiting">提现请求中...</div>
	    </div>
	</div>
	
</template>
<script>
	export default{
		name:'withdrawAccount',
		data(){
			return{
				Info:JSON.parse(this.dao.get('UserWithdrawInfo')),
				RealName:'',
				isSubmiting:false
			}
		},
		methods:{
			submit(){
 		 		var that=this;
 		 		that.isSubmiting=true;
 		 		var param={
					RealName:this.RealName,
					Token:this.Info.Token,
				}
				that.postRequest({
					
					url:that.Api.withdraw,
					params:param 
				
				}).then(res => {
					that.isSubmiting=false;
					if (res&&res.IsSuccess) {
				       this.error({title:'提示',content:'提现操作成功'});
				       this.Info='';
				       this.routetokPage('/withdraw');
				    }else{
				    	this.error({title:'提示',content:res.Msg});
				    }
				});
 		 	},
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/usr/withdraw/withdrawAccount.vue